 // Define variables
 const tabLabels = document.querySelectorAll("#tabs li");
 const tabPanes = document.getElementsByClassName("tab-contents");
 const firstTab = document.getElementById('tabs').firstElementChild;
 const firstChild = document.getElementById('tab-contents').firstElementChild;
 
 
 function activateTab(e) {
   e.preventDefault();
   
   // Deactivate all tabs
   tabLabels.forEach(function(label, index){
     label.classList.remove("active");
   });
   [].forEach.call(tabPanes, function(pane, index){
     pane.classList.remove("active");
   });
   
   // Activate current tab
   e.target.parentNode.classList.add("active");
   const clickedTab = e.target.getAttribute("data-target");
   document.querySelector(clickedTab).classList.add("active");
 }
 
 // Apply event listeners
 tabLabels.forEach(function(label, index){
   label.addEventListener("click", activateTab);
 });
 
 firstTab.classList.add('active');
 firstChild.classList.add('active');